import React from 'react';
import { contact, site, textures } from '../../data/site';
export function ContactSection() {
  return <>
      {/* Ink wash band: the page dissolves from Paper into Ink, like fog settling over the treeline. */}
      <img src={textures.wash} alt="" aria-hidden="true" loading="lazy" decoding="async" className="block h-[160px] w-full object-cover sm:h-[220px] md:h-[280px] lg:h-[320px]" data-id="element-72" data-mp="koew5jtu0mfm" />
      <section id="contact" aria-labelledby="contact-title" className="grain grain-dark scroll-mt-16 bg-ink text-paper md:scroll-mt-[72px]" data-id="element-73" data-mp="ujovu0wrchq8">
        <div className="mx-auto max-w-page px-6 py-24 md:px-12 md:py-32 xl:px-20" data-id="element-74" data-mp="13ctoqbjss8ij">
          <h2 id="contact-title" className="max-w-[20ch] font-display text-[34px] font-light leading-[1.12] tracking-[-0.01em] text-paper md:text-[52px] lg:text-[60px] lg:leading-[1.08]" data-id="element-75" data-mp="zdktt3d0u4le">
            {contact.statement}
          </h2>
          <div className="mt-14 md:mt-20" data-id="element-76" data-mp="3lilbmipkgxnm">
            <p className="flex items-center gap-4 text-[17px] text-fog md:text-[19px]" data-id="element-77" data-mp="3ljwdue3d5xcm">
              <span aria-hidden="true" className="h-px w-6 shrink-0 bg-lichen" data-id="element-78" data-mp="3qi7nootns7uu" />
              {contact.prompt}
            </p>
            <a href={`mailto:${site.email}`} className="mt-4 inline-block border-b border-paper/40 pb-1 font-display text-[28px] leading-[1.2] text-paper transition-[border-color] duration-150 ease-quiet hover:border-paper focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-paper sm:text-[36px] md:text-[48px]" data-id="element-79" data-mp="3vf7x99ppvsqp">
              {site.email}
            </a>
          </div>
        </div>
      </section>
    </>;
}